import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'launchpad-headline-al-v1',
  templateUrl: './launchpad-headline-al-v1.component.html',
  styleUrls: ['./launchpad-headline-al-v1.component.scss']
})
export class LaunchpadHeadlineAlV1Component implements OnInit {

  @Input() props: any = {}
  @Input() lifetimeSavingsAmount: string = "";

  public configObj: any = {
    appName: 'b4u',
    bannerDomain: '',
  };

  constructor() { }

  ngOnInit(): void {
    if (window.location.href.includes('local')) {
      this.configObj['bannerDomain'] = "https://www-qa1.safeway.com";
    }
  }

  ngOnChanges() {
    if(this.lifetimeSavingsAmount && Object.keys(this.props).length > 0 && this.props.savingsText) {
      this.props.savingsText = this.props.savingsText.replace("{{lifetimeSavingsAmount}}", this.lifetimeSavingsAmount.toString());
    }
  }

}
